export const DAEMON_STATUS = {
    INIT: "INIT", // only the entity is created, before payment
    READY_TO_START: "READY_TO_START", // paid but not deployed
    STARTING: "STARTING", // deploying
    RESTARTING: "RESTARTING", // redeploying
    DELETING: "DELETING", // deleting
    UP: "UP", // deployed and working
    DOWN: "DOWN", // not paid
    ERROR: "ERROR", // error during deployment
};

export const ORDER_STATUS = {
    PROCESSING: "PROCESSING", // waiting for payment
    SUCCESS: "SUCCESS", // payment successful
    FAILED: "FAILED", // payment failed
};

export const EVM_TRANSACTION_STATUS = {
    PENDING: "PENDING", // transaction pending
    SUCCESS: "SUCCESS", // transaction successful
    FAILED: "FAILED", // transaction failed
};

export const TOP_UP_AVAILABLE_STATUSES = [
    DAEMON_STATUS.UP,
    DAEMON_STATUS.DOWN,
    DAEMON_STATUS.READY_TO_START,
];
export const SETUP_DAEMON_AVAILABLE_STATUSES = [DAEMON_STATUS.INIT];
export const HAAS_BANNER_VISIBLE = [ORDER_STATUS.FAILED, DAEMON_STATUS.INIT];

export const EDIT_CONFIG_UNVAILABLE_STATUSES = [DAEMON_STATUS.STARTING, DAEMON_STATUS.RESTARTING];
